 import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PopChannelsComponent } from 'src/app/components/pop-channels/pop-channels.component';
import { PopTermsComponent } from 'src/app/components/pop-terms/pop-terms.component';
import { Service } from 'src/app/services';
import { LoadingScreenService } from 'src/app/services/loading-screen/loading-screen.service';
import { GlobalService } from '../../../../../global.service';
interface promoList {
  idPlan: number,
  data: []
}
@Component({
  selector: 'app-additional-service',
  templateUrl: './additional-service.component.html',
  styleUrls: ['./additional-service.component.sass']
})
export class AdditionalServiceComponent implements OnInit {
  @Input() currentParentCartId: any;
  @Input() sva: any;
  @Input() svaCart: any;
  @Input() itemsCart: any;
  @Input() indexTab: any;
  @Input() selectsToDisplay: any;
  @Input() selectMonthlyRent: any;
  @Input() selectPayToday: any;
  @Input() currentIndex: any;
  @Input() currentParentProductId: any;
  @Output() itemsCartValueOut = new EventEmitter<any>();
  @Output() continueSva = new EventEmitter<any>();
  @Output() defaultTabOut = new EventEmitter<any>();
  @Output() resetDataSvaOut = new EventEmitter<any>();
  @Output() dataPlanSelect = new EventEmitter<any>();
  @Output() selectPayTodayOut = new EventEmitter<any>();
  @Output() selectMonthlyRentOut = new EventEmitter<any>();
  @Output() selectsToDisplayOut = new EventEmitter<any>();
  public hideArrows: boolean = true;
  public templateTermSva: string = 'app/terms/terms.sva.html';
  public rotationTime: number = 0;
  public svaCarrousel: any []=[];
  public svaSelected: any = [];
  public svaBitInclude: any = [];
  public checkterms: boolean = false;
  public activeBundle: boolean = true;
  public promoList: any = [];
  public nameDevice: string = "";
  updateItemsSva: Subscription | undefined;
  public checkDVR: boolean = false;
  constructor(public dialog: MatDialog, private services: Service, private loadingScreenService: LoadingScreenService, public global: GlobalService, private router: Router, private route: ActivatedRoute) {
    let w: number;
    this.global.resizeObservable.subscribe((e: any) => {
      if (e.target.innerWidth !== w) {
        this.carouselSetup();
      }
      w = e.target.innerWidth;
    });
   }
  ngOnInit(): void {
    this.rotationTime = this.global.rotationTimeSva;
    this.calculateAddOns();
    this.global.tokenShop=sessionStorage.getItem("tokenShop");
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes["itemsCart"] != undefined) {
      this.itemsCart = changes["itemsCart"].currentValue;
    }
    this.init();
    this.calculateNameDevice();
  }
  openPupUp(id: any, name: string,idAddOn:number=0) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { planId: id, planName: name,idAddOn:idAddOn };
    const dialogRef = this.dialog.open(PopChannelsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
    });
  }
  calculateNameDevice() {
    let count = -1
    for (let i = 0; i < this.itemsCart.products.length; i++) {
      if (this.itemsCart.products[i].equipment == true) {
        count++
        if (count == this.currentIndex) {
          this.nameDevice = this.itemsCart.products[i].productName
        }
      }
    }
  }
  init() {
    this.svaCarrousel = [];
    for (let i = 0; i < this.sva.length; i++) {
      this.sva.selected = false;
    }
    this.carouselSetup();
    this.loadSva();
  }
  calculateAddOns() {
    for (let i = 0; i < this.sva.length; i++) {
      this.services.addOnsPromo(this.sva[i].planId,this.global.tokenShop).subscribe((data: any) => {
        let json: promoList = {
          idPlan: this.sva[i].planId,
          data: data
        }
        this.promoList.push(json);
      },error => this.global.errorHandling(error));
      if(i==this.sva.length - 1 ){
        this.loadingScreenService.stopLoading();
      }
    }
  }
 loadSva() {
    this.svaSelected = [];
    for (let i = 0; i < this.sva.length; i++) {
      this.sva[i].selected = false;
      if (this.sva[i].bitInclude == true) {
        this.sva[i].selected = true;
        this.svaSelected.push(this.sva[i]);
      }
    }
    for (let i = 0; i < this.sva.length; i++) {
      for (let j = 0; j < this.svaCart.length; j++) {
        if (this.svaCart[j] == this.sva[i].planId) {
          this.svaSelected.splice(i, 1);
          this.sva[i].selected = !this.sva[i].selected;
          this.svaSelected.push(this.sva[i]);
          this.checkterms = true;
        }
      }
    }
  }
  comboGroupIPTV(sva: any) {
    let productCombo: any = []
    for (let i = 0; i < sva.productsExlude.split(',').length; i++) {
      productCombo[i] = sva.productsExlude.split(',')[i]
    }
    for (let i = 0; i < this.svaSelected.length; i++) {
      for (let j = 0; j < productCombo.length; j++) {
        if (this.svaSelected[i].planId == productCombo[j]) {
          this.svaSelected[i].selected = false;
          this.svaSelected.splice(i, 1);
        }
      }
    }
    for (let i = 0; i < this.svaSelected.length; i++) {
      for (let j = 0; j < productCombo.length; j++) {
        if (this.svaSelected[i].planId == productCombo[j]) {
          this.svaSelected[i].selected = false;
          this.svaSelected.splice(i, 1);
        }
      }
    }
  }
  selectSva(sva: any) {
    if(sva.bitInclude == false || sva.bitInclude == undefined) {
      sva.selected = !sva.selected;
      let addItem = true;
      for (let i = 0; i < this.svaSelected.length; i++) {
        if (this.svaSelected[i].planId == sva.planId) {
          this.svaSelected.splice(i, 1);
          for (let j = 0; j < this.itemsCart.products.length; j++) {
            if (this.itemsCart.products[j].productId == sva.planId && this.itemsCart.products[j].parentCartId == this.currentParentCartId) {
                this.loadingScreenService.startLoading();
                this.services.deleteItem(this.itemsCart.products[j].cartId, 0, this.global.tokenShop).subscribe((data: any) => {
                if (data.hasError == false) {
                  this.loadingScreenService.stopLoading();
                  this.continueSva.emit();
                }
              },error => this.global.errorHandling(error));
            }
          }
          addItem = false;
        }
      }
      if (addItem == true) {
        this.svaSelected.push(sva);
      }
      this.packetRuleIptv(sva.planId);
    }
  }
  searchBundle() {
    let indexBundle = -1;
    for (let i = 0; i < this.sva.length; i++) {
      if (this.sva[i].planId == this.global.bundleId) {
        indexBundle = i;
      }
    }
    return indexBundle;
  }
  pushBundle(id: number, index: number, deleteElemt: any) {
    if (id == this.global.packBundleId[0] || id == this.global.packBundleId[1]) {
      deleteElemt.push(index);
    }
    return deleteElemt;
  }
  pushBundleIptv(id: number, index: number, deleteElemt: any, productsExlude: any) {
    if (id == productsExlude) {
      deleteElemt.push(index);
    }
    return deleteElemt;
  }
  deleteGroup(ids: any) {
    let count=0;
    for (let i = 0; i < this.svaSelected.length; i++) {
      for (let j = 0; j < ids.length; j++) {
        if(this.svaSelected[i].planId==ids[j]){
          this.svaSelected[i].selected = false;
          count++;
        }
      }
    }
    if(count>0){
      let temp=this.svaSelected;
      this.svaSelected=[];
      for (let i = 0; i < temp.length; i++) {
        for (let j = 0; j < ids.length; j++) {
          if(temp[i].planId!=ids[j]){
            this.svaSelected.push((temp[i]));
          }
        }
      }
    }
  }
  groupBundle(indexBundle: any, deleteElemt: any) {
    this.sva[indexBundle].selected = true;
    this.svaSelected.push((this.sva[indexBundle]));
    for (let i = 0; i < deleteElemt.length; i++) {
      if (i == 0) {
        this.svaSelected[deleteElemt[i]].selected = false;
        this.svaSelected.splice(deleteElemt[0], 1);
      }
      else {
        this.svaSelected[deleteElemt[i] - 1].selected = false;
        this.svaSelected.splice((deleteElemt[i] - 1), 1);
      }
    }
  }
  deleteBundle() {
    for (let i = 0; i < this.svaSelected.length; i++) {
      if (this.svaSelected[i].planId == this.global.bundleId) {
        this.svaSelected[i].selected = false;
      }
    }
    for (let i = 0; i < this.svaSelected.length; i++) {
      if (this.svaSelected[i].planId == this.global.bundleId) {
        this.svaSelected.splice(i, 1);
      }
    }
  }

  packetRuleIptv(id: any) {
    let deleteElemt: any = [];
    let countGroup: number = 0;
    let hasGroup = false;
    let groupId: any= [];
    let groupIndex: any = [];
    for (let i = 0; i < this.sva.length; i++) {
      //buscar a los hijos del padre y los elimina en caso de que esten marcados
      if (this.sva[i].planId == id && this.sva[i].productsExlude != "") {
        hasGroup = true;
        groupId = this.sva[i].productsExlude.split(',');
        for (let k = 0; k < this.svaSelected.length; k++) {
          for (let j = 0; j < groupId.length; j++) {
            if (this.svaSelected[k].planId ==  groupId[j]) {
              deleteElemt.push(this.svaSelected[k].planId);
            }
          }
        }
        this.deleteGroup(deleteElemt);
        }
    }
    if (hasGroup == false) {
      //arma el grupo donde se consiga al canal
      for (let i = 0; i < this.sva.length; i++) {
        if (this.sva[i].productsExlude != "") {
          groupId = this.sva[i].productsExlude.split(',');
          for (let j = 0; j < groupId.length; j++) {
            if (groupId[j] == id) {
              groupIndex.push(i);
            }
          }
        }
      }
      for (let i = 0; i < groupIndex.length; i++) {
        groupId = this.sva[groupIndex[i]].productsExlude.split(',');
        for (let j = 0; j < groupId.length; j++) {
          for (let k = 0; k < this.svaSelected.length; k++) {
            if (this.svaSelected[k].planId == groupId[j]) {
              countGroup++;
            }
          }
        }
        if (countGroup == groupId.length) {
          for (let k = 0; k < this.svaSelected.length; k++) {
            for (let j = 0; j < groupId.length; j++) {
              if(this.svaSelected[k].planId==groupId[j]){
                this.svaSelected[k].selected = false;
              }
            }
          }
          this.sva[groupIndex[i]].selected = true;
          this.svaSelected.push((this.sva[groupIndex[i]]));
          let temp= this.svaSelected;
          this.svaSelected=[];
          //elimina los excluyentes
          for (let j = 0; j < temp.length; j++) {
            if (this.sva[groupIndex[i]].productsExlude.search(temp[j].planId) == -1) {
              this.svaSelected.push((temp[j]));
            }
          }
        }
        else {
          for (let k = 0; k < this.svaSelected.length; k++) {
            if (this.svaSelected[k].planId == this.sva[groupIndex[i]].planId) {
              this.svaSelected[k].selected = false;
              this.deleteGroup([this.svaSelected[k].planId]);
            }
          }
        }
      }
    }
  }
  pupOpTermns() {
    let templatePath = 'assets/template/terms-sva-clarotv.html';
    this.termsSva(templatePath);
  }
  termsSva(templatePath: string) {
    let title = 'Términos y Condiciones de Servicios Adicionales';
    this.global.showTerms('template', title, templatePath, true,false).subscribe(data => {
      if (data == 'continue') {
        this.checkterms = true
        this.continue();
      }
    });
  }
  save() {
    if (this.checkterms == true && this.svaSelected.length > 0) {
      let namesSva = '';
      let priceSva = 0;
      for (let i = 0; i < this.svaSelected.length; i++) {
        if (i > 0) {
          namesSva = namesSva + "/";
        }
        namesSva = namesSva + this.svaSelected[i].planName;
        priceSva = priceSva + this.svaSelected[i].decPrice;
      }
      let items: any = [];
      this.global.cartItems = [];
      this.global.searchItemsDelete(this.itemsCart, 'sva', this.currentParentCartId).subscribe((hasError) => {
        for (let i = 0; i < this.svaSelected.length; i++) {
          items = this.global.addToCart(this.currentParentCartId, this.currentParentProductId, this.svaSelected[i].planId, this.global.creditClass, this.svaSelected[i].decPrice, 0, this.svaSelected[i].decPrice, 1, 0, 'add');
        }
        this.global.sendCart(items,this.currentParentProductId).subscribe((hasError) => {
          if (hasError == false) {
            this.continueSva.emit(this.svaSelected.length);
          }
        });
      });
    }
  }
  continue() {
    if (this.checkterms == true && this.svaSelected.length > 0) {
      this.save();
    }
    else if (this.svaSelected.length == 0) {
      this.continueSva.emit(this.svaSelected.length);
    }
    else {
      let title = 'Términos y Condiciones ';
      let templetePath = 'assets/template/terms-sva.html';
      this.global.showTerms('template', title, templetePath, true).subscribe(data => {
        if (data == 'continue') {
          this.checkterms = true
          this.continue();
        }
      });
    }
  }
  carouselSetup() {
    if (window.innerWidth > 1280) {
      this.svaCarrousel = this.global.createAdaptiveJson(this.svaCarrousel, this.sva, 4);
    }
    else if (window.innerWidth > 968 && window.innerWidth <= 1280) {
      this.svaCarrousel = this.global.createAdaptiveJson(this.svaCarrousel, this.sva, 3);
    }
    else if (window.innerWidth > 640 && window.innerWidth <= 968) {
      this.svaCarrousel = this.global.createAdaptiveJson(this.svaCarrousel, this.sva, 2);
    }
    else {
      this.svaCarrousel = this.global.createAdaptiveJson(this.svaCarrousel, this.sva, 1);
    }
    if(this.svaCarrousel.length>1){
      this.hideArrows=false;
    }
  }
  popTermOffers(text: string) {
    let title = 'Términos y Condiciones de la oferta';
    let templetePath = text;
    this.global.showTerms('', title, templetePath, false).subscribe(data => {
    });
  }
}
